__turbopack_context__.v({
  "vimeo-player": "vimeo-player-component-module-scss-module__uXff6G__vimeo-player",
  "vimeo-player__iframe": "vimeo-player-component-module-scss-module__uXff6G__vimeo-player__iframe",
  "vimeo-player__play-button": "vimeo-player-component-module-scss-module__uXff6G__vimeo-player__play-button",
  "vimeo-player__preview": "vimeo-player-component-module-scss-module__uXff6G__vimeo-player__preview",
  "vimeo-player__preview-wrapper": "vimeo-player-component-module-scss-module__uXff6G__vimeo-player__preview-wrapper",
  "vimeo-player__video-frame": "vimeo-player-component-module-scss-module__uXff6G__vimeo-player__video-frame",
});
